import React from "react";
import ERA from "./era_view/ERA";
import EraToolbar from "./era_toolbar/EraToolbar";
import {Header,SideNavbar,TokenCheck} from '../index';


class ERA_Wrapper extends React.Component {
  render() {
    return (
      <div>
        <TokenCheck/>
        <Header />
        <SideNavbar />
        <div className="body-content">
          <div className="page-title">Electronic Remittance</div>
          <div className="page-subtitle">Subtitle</div>

        <div className="status-content">
          <EraToolbar/>
          <ERA />
        </div>
      </div>
      </div>
    );
  }
}
export default ERA_Wrapper;



// WEBPACK FOOTER //
// ./src/app/era/ERA_Wrapper.js